<div *ngIf="imagePath" class="main-item__image">
    <img [src]="getMediumImage(imagePath)" class="img-thumbnail main-item__image-img">
    <div class="buttons buttons-center">
        <button class="main-item__image-zoom btn-1" mat-mini-fab aria-label="Ampliar imagen del cartel" (click)="viewImage()">
          <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
</div>
